import React from "react";
import Icon from "./Icon";
import "./SocialLinks.css";

export const INSTAGRAM_URL = "https://www.instagram.com/thebugfrogfoundation/";
const INSTAGRAM_HANDLE = "@thebugfrogfoundation";

// Round email + Instagram icon links. `email` picks which inbox the mail
// icon opens (info@ in the footer, volunteer@ on Busy Bees).
export default function SocialLinks({ email, className = "" }) {
  return (
    <div className={`social-links ${className}`.trim()}>
      <a href={`mailto:${email}`} className="social-link" aria-label={`Email ${email}`} title={email}>
        <Icon name="mail" size={22} />
      </a>
      <a
        href={INSTAGRAM_URL}
        className="social-link"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Instagram ${INSTAGRAM_HANDLE} (opens in a new tab)`}
        title={INSTAGRAM_HANDLE}
      >
        <Icon name="instagram" size={22} />
      </a>
    </div>
  );
}
